import "./TransferSection.scss";

export const TransferSection = () => {
  return (
    <section id="transfer" className="transfer-section">
      <div className="transfer-content">
      <div className="transfer-header">
        <h2>Transzfer</h2>

        <p className="transfer-intro">
          Hajnali <strong>01:15 és 04:15</strong> között igény és
          elérhetőség mentén rendelkezésünkre áll majd transzfer
          opció Etyeken belüli vagy Etyek környéki szállásra, amelynek igénybevétele díjtalan Számotokra.
        </p>

        <p className="transfer-intro">
          Előre jelezni sem szükséges, amikor elfáradtok,
          akkor indul az autó, amint szabad lesz.
        </p>
      </div>
      </div>
    </section>
  );
};